import { render, staticRenderFns } from "./Detalhado.vue?vue&type=template&id=cfadf45c&"
import script from "./Detalhado.vue?vue&type=script&lang=js&"
export * from "./Detalhado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports